module.exports = __webpack_public_path__ + "img/labmem_text_language_en.e5f0717c.png";